/* eslint-disable @typescript-eslint/no-empty-interface */
const config = { domain: 'Fundraising', subdomain: 'FunderFinder' }

interface FunderProfileClicked {
  funderName: string
}

interface FunderSaved {
  funderName: string
}

interface NavigationItemClicked {}

interface PageClicked {}

interface PaginationClicked {}

interface FilterResultsClicked {}

interface GuideViewed {}

interface DismissGuideClicked {}

interface HideMobileGuideClicked {}

interface RecallGuideClicked {}

interface ExpandGuideClicked {}

interface MinimizeGuideClicked {}

interface GuideCourseClicked {
  courseId: string
  courseTitle: string
}

interface GuideResourceClicked {
  resourceId: string
  resourceName: string
}

interface NavigationToolTip {
  tipId: string
}

export const funderFinder = {
  Clicked: {
    Clicked: (param: NavigationItemClicked) => param,
    config,
  },
  Profile_Clicked: {
    Profile_Clicked: (param: FunderProfileClicked) => param,
    config,
  },
  Save_Funder_Clicked: {
    Save_Funder_Clicked: (param: FunderSaved) => param,
    config,
  },

  Grants_Tab_Clicked: {
    Grants_Tab_Clicked: (param: PageClicked) => param,
    config,
  },

  Grants_Pagination_Backward_Clicked: {
    Grants_Pagination_Backward_Clicked: (param: PaginationClicked) => param,
    config,
  },

  Grants_Pagination_Forward_Clicked: {
    Grants_Pagination_Forward_Clicked: (param: PaginationClicked) => param,
    config,
  },

  Funder_Pagination_Backward_Clicked: {
    Funder_Pagination_Backward_Clicked: (param: PaginationClicked) => param,
    config,
  },

  Funder_Pagination_Forward_Clicked: {
    Funder_Pagination_Forward_Clicked: (param: PaginationClicked) => param,
    config,
  },
  Filter_Results_Clicked: {
    Filter_Results_Clicked: (param: FilterResultsClicked) => param,
    config,
  },
  Guide_Viewed: {
    Guide_Viewed: (param: GuideViewed) => param,
    config,
  },
  Dismiss_Guide_Clicked: {
    Dismiss_Guide_Clicked: (param: DismissGuideClicked) => param,
    config,
  },
  Hide_Mobile_Guide_Clicked: {
    Hide_Mobile_Guide_Clicked: (param: HideMobileGuideClicked) => param,
    config,
  },
  Recall_Guide_Clicked: {
    Recall_Guide_Clicked: (param: RecallGuideClicked) => param,
    config,
  },
  Expand_Guide_Clicked: {
    Expand_Guide_Clicked: (param: ExpandGuideClicked) => param,
    config,
  },
  Minimize_Guide_Clicked: {
    Minimize_Guide_Clicked: (param: MinimizeGuideClicked) => param,
    config,
  },
  Guide_Course_Clicked: {
    Guide_Course_Clicked: (param: GuideCourseClicked) => param,
    config,
  },
  Guide_Resource_Clicked: {
    Guide_Resource_Clicked: (param: GuideResourceClicked) => param,
    config,
  },
  Tip_Viewed: {
    Tip_Viewed: (param: NavigationToolTip) => param,
    config,
  },
  Acknowledge_Tip_Clicked: {
    Acknowledge_Tip_Clicked: (param: NavigationToolTip) => param,
    config,
  },
  Celebration_Viewed: {
    Celebration_Viewed: (param: NavigationToolTip) => param,
    config,
  },
}
